import DocumentRevisionsRequest from '../ws/DocumentRevisionsRequest';
import CreateDocumentRevisionRequest from '../ws/CreateDocumentRevisionRequest';
import CreateDocumentRevisionBatchRequest from '../ws/CreateDocumentRevisionBatchRequest';
import { DOCUMENT_FORM_ERROR, DOCUMENT_FORM_SET_LOADING } from './documentFormActions';
import { I18nUtils } from '../../../i18n/I18nUtils';
import Alert from 'react-s-alert';
import { push } from 'react-router-redux';
import { PsRoutes } from '../../shared/routing/Routes';
import { ATTACHMENT } from '../../attachment/attachmentActions';

export const DOCUMENT_REVISIONS_UPDATE = 'document-revisions-update';
export const DOCUMENT_REVISIONS_ERROR = 'document-revisions-error';
export const DOCUMENT_REVISIONS_SET_LOADING = 'document-revisions-set-loading';
export const DOCUMENT_REVISION_CREATED = 'document-revision-created';
export const DOCUMENT_REVISION_BATCH_LOADING = 'document-revision-batch-loading';
export const DOCUMENT_REVISION_BATCH_SUCCEED = 'document-revision-batch-succeed';
export const DOCUMENT_REVISION_BATCH_FAILED = 'document-revision-batch-failed';
export const DOCUMENT_LAST_REVISIONS_SET_LOADING = 'document-last-revisions-set-loading';
export const DOCUMENT_LAST_REVISIONS_UPDATE = 'document-last-revisions-update';

export const getDocumentRevisions = (id, page = 1, search = '', filter = 0, document_type_id = null) => (dispatch) => {

    new DocumentRevisionsRequest(id, page, search, filter, document_type_id)
        .onPreExecution(() => {
            dispatch({type: DOCUMENT_REVISIONS_SET_LOADING, id: id, payload: true});
        })
        .onSuccess(response => {
            dispatch({
                type: DOCUMENT_REVISIONS_UPDATE,
                id: id,
                payload: response,
            });
            if (page === 1) {
                dispatch({
                    type: DOCUMENT_LAST_REVISIONS_UPDATE,
                    id: id,
                    payload: response,
                });
            }
        })
        .onFail(error => {
            dispatch({type: DOCUMENT_REVISIONS_ERROR, id: id, payload: error});
        })
        .onPostExecution(() => {
            dispatch({type: DOCUMENT_REVISIONS_SET_LOADING, id: id, payload: false});
        })
        .execute();

};

export const createDocumentRevision = (document) => (dispatch) => {
    new CreateDocumentRevisionRequest(document)
        .onPreExecution(() => {
            dispatch({type: DOCUMENT_FORM_SET_LOADING, payload: true});
        })
        .onSuccess(response => {
            Alert.success(I18nUtils.tr('TR_CREATE_DOCUMENT_REVISION_SUCCESS'));
            dispatch({
                type: DOCUMENT_REVISION_CREATED,
                payload: response.data.id,
                rntInfo: response.data.rnt_info,
            });
        })
        .onFail(error => {
            dispatch({type: DOCUMENT_FORM_ERROR, payload: error});
            Alert.error(error || I18nUtils.tr('TR_CREATE_DOCUMENT_REVISION_ERROR'));
        })
        .onPostExecution(() => {
            dispatch({type: DOCUMENT_FORM_SET_LOADING, payload: false});
        })
        .execute();

};

export const createDocumentRevisionBatch = (document) => (dispatch) => {

    new CreateDocumentRevisionBatchRequest(document)
        .onPreExecution(
            () => {
                dispatch({
                    type: DOCUMENT_REVISION_BATCH_LOADING,
                    payload: true
                });
            }
        )
        .onSuccess(
            response => {
                Alert.success(I18nUtils.tr('TR_CREATE_DOCUMENT_REVISION_BATCH_SUCCESS'));
                dispatch({
                    type: DOCUMENT_REVISION_BATCH_SUCCEED,
                    payload: response.data,
                });
                dispatch({ type: ATTACHMENT.CLEAR });
                dispatch(push(PsRoutes.DOCUMENTS_ATTACHMENT_SUMMARY));
            }
        )
        .onFail(
            error => {
                dispatch({
                    type: DOCUMENT_REVISION_BATCH_FAILED,
                    payload: error
                });
                Alert.error(error || I18nUtils.tr('TR_CREATE_DOCUMENT_REVISION_BATCH_ERROR'));
            })
        .onPostExecution(
            () => {
                dispatch({
                    type: DOCUMENT_REVISION_BATCH_LOADING,
                    payload: false
                });
            })
        .execute();

};

export const getFirstDocumentRevisions = (id, page = 1, search = '', filter = 0, document_type_id = null) => (dispatch) => {

    new DocumentRevisionsRequest(id, page, search, filter, document_type_id)
        .onPreExecution(() => {
            dispatch({type: DOCUMENT_LAST_REVISIONS_SET_LOADING, id: id, payload: true});
        })
        .onSuccess(response => {
            dispatch({
                type: DOCUMENT_LAST_REVISIONS_UPDATE,
                id: id,
                payload: response,
            });
        })
        .onPostExecution(() => {
            dispatch({type: DOCUMENT_LAST_REVISIONS_SET_LOADING, id: id, payload: false});
        })
        .execute();

};



// WEBPACK FOOTER //
// ./src/app/documents/actions/documentRevisionsActions.js